import React from 'react';
import { makeStyles } from '@material-ui/core';
import config from '../../preorder/configs/config';

const useStyle = makeStyles((theme) => ({
  button: {
    color: 'rgb(243,212,32)',
    background: '#000000',
    display: 'block',
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: theme.spacing(-1),
    padding: theme.spacing(1),
    textAlign: 'center',
    textDecoration: 'none',
    width: '100%',

    '&:visited': {
      color: 'rgb(243,212,32)',
    },
  },
}));
export default () => {
  const classes = useStyle();
  return (
    <div>
      <img src={`${config.RESOURCE_URI}CS/W35_CS_moon_edm1.jpg`} alt="" width="100%" />
      <img src={`${config.RESOURCE_URI}CS/W35_CS_moon_edm2.jpg`} alt="" width="100%" />
      <a href="/menu?filter=PRE_ORDER" className={classes.button}>點我逛菜單</a>
    </div>
  );
};
